// API katmanı — Hibrit yapı:
// - Cities (statik, 82 il/978 ilçe) → cities.js (instant, SEO mükemmel)
// - Listing/Detail (dinamik ilanlar) → gercekbachend.site/api (backend)
import axios from "axios";
import { CITIES_FULL, TOTAL_CITIES_FULL, TOTAL_DISTRICTS_FULL } from "@/lib/cities";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://gercekbachend.site";
const API = `${API_BASE}/api`;

// In-memory cache (sayfa içi tekrar fetch'i önler)
const _listingCache = {};
const _adCache = {};

// Cities — statik, instant
export const fetchCities = () => ({
  cities: CITIES_FULL,
  total_cities: TOTAL_CITIES_FULL,
  total_districts: TOTAL_DISTRICTS_FULL,
});

// Listing — backend'den fetch
export const fetchListing = async (citySlug, district = null) => {
  const key = `${citySlug}/${district || ""}`;
  if (_listingCache[key]) return _listingCache[key];
  const url = district
    ? `${API}/listing/${citySlug}?district=${district}`
    : `${API}/listing/${citySlug}`;
  try {
    const r = await axios.get(url, { timeout: 12000 });
    _listingCache[key] = r.data;
    return r.data;
  } catch (e) {
    console.error("fetchListing error:", e?.response?.data || e.message);
    return null;
  }
};

// Detail — backend'den fetch
export const fetchAd = async (adId, c) => {
  const key = `${adId}|${c || ""}`;
  if (_adCache[key]) return _adCache[key];
  try {
    const r = await axios.get(`${API}/ad/${adId}?c=${encodeURIComponent(c || "")}`, { timeout: 12000 });
    _adCache[key] = r.data;
    return r.data;
  } catch (e) {
    console.error("fetchAd error:", e?.response?.data || e.message);
    return null;
  }
};

export const ADMIN_WHATSAPP = "+905350000000";
export const ADMIN_DIGITS = "905350000000";
